module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-megastar.9f983dd3.jpg";